module.exports = __webpack_public_path__ + "static/media/sfl_1.38790b2d.jpg";